module.exports = __webpack_public_path__ + "static/img/picture11.7ac5b13b.png";